// Urban/intermix node_type values used for filtering and counting.
export const STRUCTURE_VALUES = ["structure", "spotting_structure"];
export const VEGETATION_VALUES = ["vegetation", "spotting_vegetation"];
